import { render, staticRenderFns } from "./TableColumnButton.vue?vue&type=template&id=0d8a6858"
import script from "./TableColumnButton.vue?vue&type=script&lang=js"
export * from "./TableColumnButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports